module.exports = __webpack_public_path__ + "img/logo.50616219.png";